import { render, staticRenderFns } from "./AgencyMessageFeedSection.vue?vue&type=template&id=50b38e6a"
import script from "./AgencyMessageFeedSection.vue?vue&type=script&lang=js"
export * from "./AgencyMessageFeedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports